import type ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import type { AnimationPreference } from 'owa-outlook-service-option-store';

interface MailLayoutStore {
    clientReadingPanePosition: ReadingPanePosition | null;
    showAllAccountsNode: boolean; // If Unified Inbox node is shown in folder pane
    showReadingPane: boolean;
    showListPane: boolean;
    showFolderPane: boolean;
    showFolderPaneAsTransientOverlay: boolean;
    showFolderPaneOverlayAsBlocking: boolean;
    useSingleLineMessageListWithRightReadingPane: boolean;
    animationPreference: AnimationPreference;
    shouldAnimate: boolean;

    // Column width values for SLV
    senderColumnWidth: number | null;
    subjectColumnWidth: number | null;
    receivedColumnWidth: number | null;
    sortedContentColumnWidth: number | null;

    // Height of the pinned Favorites section is set by the user
    favoritesPaneHeight: number | null;
}

export default MailLayoutStore;

export enum ListViewLayout {
    SingleLine,
    ThreeLine,
}
